import React from 'react';
import Arrow from '../../images/arrow-right-green.svg'

const TellUs = () => {
    return (
      <section id="tell-us-section">
        <div className="container">
          <div className="row">
            <div className="col-md-12 mb-4">
              <div className="tellus-txt">TELL US WHAT YOU NEED</div>
              <h1>Rehab Find is Ready to Help You</h1>
            </div>
          </div>
          <div className="row">
            <div className="col-md-6">
              <p>
                Rehab Find is here to help you find addiction rehab centres for
                your addiction concerns. We provide solutions for people that
                aim to rehabilitate and transform their lives. Our platform
                offers free resources for your rehabilitation. We give in-depth
                guides, specialist recommendations and first-hand accounts to
                guide you to sober and healthy living. Get addiction rehab
                today!
              </p>
            </div>
            <div className="col-md-6">
              <p>
                Addiction rehab is not something to be ashamed of. It is a need
                that we aid to address and help people with. That is why Rehab
                Find exists to help everyone from all walks of life in finding
                what they need to rehabilitate and transform their lives. With
                our educational materials, in-depth guides, specialist
                recommendations and addiction rehabilitation tools, Rehab Find
                continuously provides the best resources online and offline to
                help people succeed in rehabilitation.
              </p>
              <div className="rehab-find-link">
                <a href="#">
                  Learn More About Rehab Find
                  <span className="pl-2">
                    <img src={Arrow} alt="" style={{margin:"0"}}/>
                  </span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
};
 
export default TellUs;